import { pickCategoryIcon, type CategoryIconKind } from './categoryIconRules'

/**
 * SVG-иконки категорий из `src/assets/icons/categories/b`.
 *
 * Vite отдаёт их как URL: файл попадает в сборку, кешируется браузером и
 * масштабируется без потерь. Набор `b` — цветные иллюстрации на светлом фоне;
 * старый набор `a` и PNG-копии удалены.
 */
const modules = import.meta.glob('../../assets/icons/categories/b/*.svg', {
  eager: true,
  query: '?url',
  import: 'default'
}) as Record<string, string>

const URLS: Partial<Record<CategoryIconKind, string>> = {}
for (const [path, url] of Object.entries(modules)) {
  const file = path.split('/').pop() ?? ''
  const kind = file.replace(/\.svg$/, '') as CategoryIconKind
  if (kind) URLS[kind] = url
}

/** URL SVG-иконки по виду. */
export function categoryIconUrl(kind: CategoryIconKind): string | undefined {
  return URLS[kind]
}

/** URL SVG-иконки по названию категории. */
export function categoryIconUrlByName(name: string): string | undefined {
  return URLS[pickCategoryIcon(name)]
}
